import { useState } from 'react';
import { SliderNavigation } from './navigation/index.jsx';
import s from './index.module.scss';
import { Card } from '../card';
import './index.scss';
// Swiper modules
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export const Slider = ({ slides, setClosed }) => {
  const [swiperRef, setSwiperRef] = useState(null);

  const onNext = () => {
    swiperRef?.slideNext();
  };

  const onPrev = () => {
    swiperRef?.slidePrev();
  };

  if (!slides.length) return null;

  return (
    <div className={s.wrapper}>
      <div className={s.container}>
        <Swiper
          onSwiper={setSwiperRef}
          autoHeight={true}
          spaceBetween={10}
          loop
          slidesPerView={1}
          className="banner_slider"
          modules={[Pagination, Navigation, Autoplay]}
          pagination={{
            clickable: true,
          }}
          autoplay={{
            delay: 3000, // 3 seconds
            disableOnInteraction: false,
          }}
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              <Card data={slide} setClosed={setClosed} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <SliderNavigation onNext={onNext} onPrev={onPrev} />
    </div>
  );
};
